export default "__VITE_ASSET__567f8370__"